import api from 'api';

export const RECIPE_STEP_ASYNC_ACTION_START = 'RECIPE_STEP_ASYNC_ACTION_START';
export const RECIPE_STEP_ASYNC_ACTION_ERROR = 'RECIPE_STEP_ASYNC_ACTION_ERROR';
export const RECIPE_STEP_ASYNC_UPDATE_ACTION_SUCCESS = 'RECIPE_STEP_ASYNC_UPDATE_ACTION_SUCCESS';
export const RECIPE_STEP_ASYNC_ARCHIVE_ACTION_SUCCESS = 'RECIPE_STEP_ASYNC_ARCHIVE_ACTION_SUCCESS';
export const RECIPE_STEP_RESET_STATE = 'RECIPE_STEP_RESET_STATE';

function recipeStepAsyncActionStart() {
  return {
    type: RECIPE_STEP_ASYNC_ACTION_START,
  };
}

function recipeStepAsyncActionError(error) {
  return {
    type: RECIPE_STEP_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipeStepAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_STEP_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function recipeStepAsyncArchiveSuccess() {
  return {
    type: RECIPE_STEP_ASYNC_ARCHIVE_ACTION_SUCCESS,
  };
}

export function recipeStepResetState() {
  return {
    type: RECIPE_STEP_RESET_STATE,
  };
}

export function getRecipeStepAsync(id) {
  return (dispatch, getState) => {
    dispatch(recipeStepAsyncActionStart());
    return api.request(`recipeStep/?recipeStepId=${ id }`, 'get')
    .then((data) => {
      dispatch(recipeStepAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepAsyncActionError('Unable to get recipe step'));
      throw (err);
    });
  };
}

export function createRecipeStepAsync(recipeStep) {
  return (dispatch, getState) => {
    dispatch(recipeStepAsyncActionStart());
    return api.request('recipeStep', 'post', recipeStep)
    .then((data) => {
      dispatch(recipeStepAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepAsyncActionError('Unable to create recipe step'));
      throw (err);
    });
  };
}

export function updateRecipeStepAsync(recipeStep) {
  return (dispatch, getState) => {
    dispatch(recipeStepAsyncActionStart());
    return api.request('recipeStep', 'put', recipeStep)
    .then((data) => {
      dispatch(recipeStepAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepAsyncActionError('Unable to update recipe step'));
      throw (err);
    });
  };
}

export function archiveRecipeStepAsync(recipeStepId) {
  return (dispatch, getState) => {
    dispatch(recipeStepAsyncActionStart());
    return api.request(`recipeStep/archive/${ recipeStepId }`, 'post')
    .then((data) => {
      dispatch(recipeStepAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepAsyncActionError('Unable to archive recipe step'));
      throw (err);
    });
  };
}
